import { createFileRoute } from "@tanstack/react-router"
import { ConfirmEmailPage } from "@/pages"

export const Route = createFileRoute("/_unauthenticated/confirm-email")({
  component: ConfirmEmailPage,
})
